module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/11-326a6b5bd62733b58479853ae2abd1cf.jpg";